module.exports = __webpack_public_path__ + "static/media/icon-close.fa07fff6.svg";